import { createRoot } from 'react-dom/client';

import App from './App/App';

import 'virtual:theme.css';
import '@style/global.css';

const container = document.getElementById('js-mapframe');
const root = createRoot(container);

root.render(<App />);
